import { render } from "./Substep.vue?vue&type=template&id=f2b16cf4&scoped=true"
import script from "./Substep.vue?vue&type=script&lang=js"
export * from "./Substep.vue?vue&type=script&lang=js"

import "./Substep.vue?vue&type=style&index=0&id=f2b16cf4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b16cf4"]])

export default __exports__